import React, { createContext, useReducer, useState } from "react";
import { reducer } from "./GlobalReducer";

const globalState = {
};

function useAsyncReducer(reducer, initState) {
    const [state, setState] = useState(initState), dispatchState = async (action) => setState(await reducer(state, action));
    return [state, dispatchState];
}

export const GlobalStoreProvider: React.FC<any> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, globalState);

    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
};

export const Context = createContext(globalState);